import { Helmet } from "react-helmet-async";

const SITE = "https://bizarreai.fr";
const DEFAULT_DESC = "IA pour répondre, analyser, créer du contenu, débattre et connaître ses droits.";

// SEO par page pour les moteurs qui exécutent le JS (Google).
// L'aperçu social (Facebook/WhatsApp/X) est géré par les balises Open Graph statiques de public/index.html.
export default function Seo({ title, description, path = "/", noindex = false }) {
  const url = `${SITE}${path}`;
  const fullTitle = title || "BIZARRE AI";
  const desc = description || DEFAULT_DESC;
  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
    </Helmet>
  );
}
